<template lang="pug">
  b-modal#efightOutputLogInfo(
  ref="efightAPIOutputInfo"
  :title="$t('ui.efight_api_output_info')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  size="xl"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="id"
          type="text"
          v-model="id"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.video')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="videoName"
          type="text"
          v-model="videoName"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.created_on')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="createdOn"
          type="text"
          v-model="createdOn"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.output')" disabled).mb-0
        b-form-textarea(v-model="content" rows="15")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, alphaNum, integer, email, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import beautify from "xml-beautifier";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      id: "",
      content: "",
      videoName: "",
      createdOn: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      sportsType: "",
    };
  },
  computed: {
  },
  validations: {
  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    getOutputInfo: function() {
      let url = config.getEFightAPILogDetailUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.efightapilog,
        output_file_name: this.item.output_file_name,
        sports_type: this.item.sports_type
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.content = response.data.content;
              } else {
                // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            // this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          // this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    shown: function() {
      this.$v.$reset();
      this.id = this.item.id;
      this.videoName = this.item.video_name;
      this.sportsType = this.item.sports_type;
      this.createdOn = this.$moment(this.item.created_on).format("YYYY-MM-DD, HH:mm:ss");
      this.content = "";
      this.getOutputInfo();
    }
  }
};
</script>
